import gql from 'graphql-tag';

const featureAlbum = gql`
  mutation featureAlbum($id: MongoID!) {
    featuredAlbum: featureAlbum(_id: $id) {
      record {
        _id
        isFeatured
      }
    }
  }
`;

export interface featureAlbumResponse {
  featuredAlbum: {
    record: Album;
  };
}

export interface featureAlbumVariables {
  id: string;
}

export default featureAlbum;
